import Components from "../components";

class DropdownSelect extends Components.Base {
  initialize() {
    this.$items = this.$el.find(".dropdown-component__item");
    this.$inputField = this.$el.find("input[type='hidden']");
    this.$label = this.$el.find(".c-dropdown-select__label");
  }

  bind() {
    this.$items.on("click", this.onDropdownSelect.bind(this));
  }

  onDropdownSelect(evt) {
    const $item = $(evt.target).closest(".dropdown-component__item");
    this.$items.removeClass("active");
    $item.addClass("active");
    this.$label.html($item.html());
    this.$inputField.val($item.data("updatedValue"));
  }
}

Components.collection.register({
  selector: ".c-dropdown-select",
  klass: DropdownSelect,
});
